import React from 'react';
import axios from "../../containers/api";
import { showCatchError, toCurrency } from "../../helpers/Utils";
import { Button, Input, Alert, FormGroup, Label, Card, CardBody } from "reactstrap";

class OnlineCharge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Amount: null,
      errors: [],
      luckButton: false
    };
  }

  validateInputData = () => {
    this.props.closeSweetAlert();
    let error = [];
    const amount = parseInt(this.state.Amount) || 0;

    if (amount < 1000) {
      error.push("مقدار اعتبار وارد شده نباید کمتر از ۱۰۰۰ تومان باشد.");
    }

    this.setState({ errors: error });
    if (error.length === 0) {
      this.Pay();
    } else {
      this.props.showAlert("لطفا اطلاعات را به درستی وارد کنید!", "error");
    }
  };

  Pay = () => {
    const model = { Amount: parseInt(this.state.Amount) };
    this.setState({ luckButton: true });
    this.props.showSpinner();

    axios.post('/api/v1/sale-payments', model)
      .then((res) => {
        this.props.hideSpinner();
        if (res.data.statusCode === 200 && res.data.data.redirectUrl) {
          window.location.href = res.data.data.redirectUrl;
        }
        this.setState({ luckButton: false });
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        this.setState({ luckButton: false });
      });
  };

  render() {
    const { Amount, errors, luckButton } = this.state;

    return (
      <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', background: '#f8f9fa' }}>
        {/* استایل‌های داخلی */}
        <style jsx>{`
          .charge-card {
            max-width: 480px;
            width: 100%;
            border: none;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
            background: #fff;
            transition: transform 0.3s ease;
          }
          .charge-card:hover {
            transform: translateY(-8px);
          }
          .card-header-custom {
            background: linear-gradient(135deg, #4361ee, #3f37c9);
            color: white;
            padding: 1.5rem;
            text-align: center;
            font-weight: 700;
            font-size: 1.3rem;
          }
          .form-container {
            padding: 2rem;
          }
          .form-label-floating {
            position: absolute;
            top: 14px;
            right: 12px;
            font-size: 1rem;
            color: #6c757d;
            pointer-events: none;
            transition: all 0.2s ease;
            transform-origin: right;
          }
          .form-control:focus ~ .form-label-floating,
          .form-control:not(:placeholder-shown) ~ .form-label-floating {
            top: -10px;
            font-size: 0.8rem;
            color: #4361ee;
            background: white;
            padding: 0 6px;
          }
          .form-group-custom {
            position: relative;
            margin-bottom: 1.5rem;
          }
          .form-control-custom {
            border: 2px solid #e9ecef;
            border-radius: 12px;
            padding: 14px 16px;
            font-size: 1.1rem;
            text-align: left;
            direction: ltr;
            font-family: monospace;
          }
          .form-control-custom:focus {
            border-color: #4361ee;
            box-shadow: 0 0 0 0.2rem rgba(67, 97, 238, 0.25);
          }
          .btn-pay {
            background: linear-gradient(135deg, #4361ee, #3f37c9);
            border: none;
            border-radius: 14px;
            padding: 14px;
            font-size: 1.1rem;
            font-weight: 600;
            color: white;
            width: 100%;
            transition: all 0.3s ease;
            box-shadow: 0 6px 16px rgba(67, 97, 238, 0.3);
          }
          .btn-pay:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 25px rgba(67, 97, 238, 0.4);
          }
          .btn-pay:disabled {
            opacity: 0.7;
            cursor: not-allowed;
            transform: none;
          }
          .alert-custom {
            border-radius: 12px;
            border: none;
            font-size: 0.95rem;
            margin-bottom: 1rem;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.1);
          }
          .shaparak-logo {
            height: 50px;
            margin: 1rem auto;
            display: block;
            filter: grayscale(30%);
          }
          @media (max-width: 576px) {
            .charge-card { margin: 10px; }
            .form-container { padding: 1.5rem; }
          }
        `}</style>

        <Card className="charge-card">
          <div className="card-header-custom">
            شارژ آنلاین اعتبار
          </div>
          <CardBody className="form-container">
            {/* پیام‌های خطا */}
            {errors.length > 0 && (
              <div>
                {errors.map((error, i) => (
                  <Alert key={i} color="danger" className="alert-custom">
                    {error}
                  </Alert>
                ))}
              </div>
            )}

            <form onSubmit={(e) => e.preventDefault()}>
              <FormGroup className="form-group-custom">
                <Input
                  type="text"
                  className="form-control-custom"
                  value={toCurrency(Amount)}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9۰-۹]/g, "");
                    this.setState({ Amount: val });
                  }}
                  placeholder=" "
                />
                <Label className="form-label-floating">مبلغ (تومان)</Label>
              </FormGroup>

              {/* <img 
                src="https://pec.shaparak.ir/assets/images/shaparak-logo.png" 
                alt="شاپرک" 
                className="shaparak-logo"
              /> */}

              <Button
                className="btn-pay"
                onClick={() => this.props.showSweetAlert(
                  `آیا از شارژ ${toCurrency(Amount)} تومان مطمئن هستید؟`,
                  "",
                  "warning",
                  this.validateInputData
                )}
                disabled={!Amount || Amount < 1000 || luckButton}
              >
                {luckButton ? (
                  <span>در حال اتصال به درگاه...</span>
                ) : (
                  "پرداخت آنلاین"
                )}
              </Button>
            </form>

            <div style={{ marginTop: '1.5rem', textAlign: 'center', color: '#6c757d', fontSize: '0.9rem' }}>
              پرداخت امن از طریق درگاه شاپرک
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default OnlineCharge;